<template>
  <div class="Menu">
    <b-navbar toggleable="lg" type="dark" variant="info" class="container">
        <b-navbar-brand href='/'>
            <b-img class="logo" src="https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/01/60463242f5efbb3130100fab_ImSim_Logotipo_Principal_2-p-500.png"></b-img>
            <span class="clubText">UK Distributor</span>
        </b-navbar-brand>
        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
        <template v-if="this.$route.name == 'home'">
          <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                  <b-nav-item class="navItems" @click="simulator()">Simulators</b-nav-item>
                  <b-nav-item class="navItems" to="/accessories">Accessories</b-nav-item>
                  <b-nav-item class="navItems" to="/showroom" >UK Showroom</b-nav-item>
                  <b-nav-item class="navItems ArrangeDemo" href="https://apps.apple.com/gb/app/sim-park/id6738054804" target="blank" >Arrange a Demo</b-nav-item>

              </b-navbar-nav>
          </b-collapse>
        </template>
        <template v-else>
          <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                  <b-nav-item class="navItems" @click="simulator()">Simulators</b-nav-item>
                  <b-nav-item class="navItems"  to="/accessories">Accessories</b-nav-item>
                  <b-nav-item class="navItems" to="/showroom" >UK Showroom</b-nav-item>
                  <b-nav-item class="navItems ArrangeDemo" href="https://apps.apple.com/gb/app/sim-park/id6738054804" target="blank" >Arrange a Demo</b-nav-item>
                  <b-nav-item class="navItems " href="#">
                    <span v-show="getquantity != null">({{getquantity }} Item) £{{getSum}}</span> 
                    <img class="basket" src="https://wp-ocssport.ocs-sport.com/imsim-uk/wp-content/uploads/sites/8/2025/10/Icon-basket.png">
                  </b-nav-item>
              </b-navbar-nav>
          </b-collapse>
        </template>
    </b-navbar>
    <div id="myDIV" class="sims">
      <b-container>
        <b-link class="simOption" :to="'/terra'">Terra</b-link>
        <b-link class="simOption" :to="'/alma'">Alma</b-link>
        <b-link class="simOption" :to="'/garra'">Garra</b-link>
      </b-container>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Menu',
  props: {

  },
  data: function() {
    return {
      getquantity: sessionStorage.getItem("quantity"),
      getSum: sessionStorage.getItem("itemvalue")
    };
  },
  methods: {
    simulator() {
      var v = document.getElementById("myDIV");
        if (v.style.display === "none") {
            v.style.display = "block";
        } else {
            v.style.display = "none";
        }
    },
    isMobile() {
        if( screen.width <= 500 ) {
            return true;
        }
        else {
            return false;
        }
    },
    scroll() {
      var score = document.getElementById("about");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    scrolltwo() {
      var score = document.getElementById("membership");
      score.scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    },
    loadCartdata() {
      window.addEventListener('click',function(){
        document.getElementById('basket').onclick = function() {
          console.log("in event click")
          this.getquantity = sessionStorage.getItem("quantity"),
          this.getSum = sessionStorage.getItem("itemvalue")
          console.log("getquantity + sum")
          console.log(this.getquantity + ' + ' +  this.getSum)
        }
      }); 
    },

    // updateValue:function(value){
    //     let prevData = JSON.parse(sessionStorage.getItem('itemvalue'));
    //     Object.keys(value).forEach(function(val, key){
    //         prevData[val] = value[val];
    //     })
    //     sessionStorage.setItem('itemvalue', JSON.stringify(prevData));
    // },
    // updateQ:function(value){
    //     let prevData = JSON.parse(sessionStorage.getItem('quantity'));
    //     Object.keys(value).forEach(function(val, key){
    //         prevData[val] = value[val];
    //     })
    //     sessionStorage.setItem('quantity', JSON.stringify(prevData));
    // }
    // scrollthree() {
    //   var score = document.getElementById("contact");
    //   score.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //     inline: "nearest",
    //   });
    // },
    // scrollfour() {
    //   var score = document.getElementById("blog");
    //   score.scrollIntoView({
    //     behavior: "smooth",
    //     block: "start",
    //     inline: "nearest",
    //   });
    // },
  },
  watch: {
    loadCartdata(newValue) {
      
      document.getElementById('basket').onclick = function() {
        console.log("in event click")
        newValue == this.getquantity,
        newValue == this.getSum,
        console.log("newValue")
        console.log(newValue)
      }

      console.log("newValue");
      console.log(newValue);
    },
    immediate: true,
    deep: true
  },
  mounted() {
    // setTimeout(this.loadCartdata, 5000)
    this.simulator();
    window.addEventListener('mouseup',function(event){
          var pol = document.getElementById('myDIV');
          if(event.target != pol && event.target.parentNode != pol){
              pol.style.display = 'none';
          }
          this.loadCartdata();
    });   
    // this.updateValue();
    // this.updateQ();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    img.basket {
      width: 30px;
      position: relative;
      top: -4px;
      left: 5px;
    }
    .navbar-dark .navbar-nav .nav-link {
      /* color: rgb(255 255 255 / 50%); */
      z-index: 999;
      position: relative;
      color: #ffff;
      font-weight: 600;
    }
    .simOption {
      color: #000; 
      font-size: 20px;
      font-weight: bold;
      padding-right: 30px;
    }
    .simOption:hover {
      color: #FD021D; 
      text-decoration: none;
    }
    .simOption:active {
      color: #FD021D; 
      text-decoration: none;
    }
    .sims {
      background-color: #fff;
      padding-top: 15px;
      padding-bottom: 15px;
    }
    li.nav-item.navItems.ArrangeDemo {
      background-color: #FE011D;
    }
    li.nav-item.navItems.ArrangeDemo:hover {
      background-color: #FFF;
    }
    li.nav-item.navItems.appleStoreItem {
      padding-right: 0px;
    }
    li.nav-item.navItems.goolgeStoreItem {
      padding-left: 0px;
    }
    img.storeIcons {
      width: 42px;
    }
    .clubText {
      color: #ffffff;
      font-style: italic;
      font-size: 19px;
      font-weight: bold;
      position: relative;
      top: 6px;
      left: -11px;
    }
    .Menu {
      /* display: none; */
    }
    .hide {
      opacity:0;
      display: none;
    }
    .show {
      opacity: 1;
      /* background: #010322; */
      /* position: fixed; */
      width: 100%;
      z-index: 999;
    }
    img.supportLogos {
      width: 45px;
    }
    ::v-deep .btn-danger {
      color: #fff;
      background-color: #efd170;
      border-color: #efd170!important;
    }
    .navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
        color: #D80E1F;
    }
    .navItems {
        /* padding-right: 40px;
        padding-left: 40px; */
        padding-right: 21px;
        padding-left: 21px;
        line-height: 3;
        scroll-behavior: smooth;
        color:#fff;
    }
    .navItems:hover {
        /* padding-right: 30px;
        padding-left: 30px; */
        line-height: 3;
        scroll-behavior: smooth;
        color:rgb(232 63 75);
        text-decoration: none;
    }
    .logo {
        width: 190px;
      margin-left: -40px;
    }
    .Menu {
        background-color: #000 !important;
        padding-top: 0px;
        padding-bottom: 0px;
    }
    .bg-info {
        background-color: #000 !important;
    }
    .navbar-light .navbar-nav .nav-link {
        color: #fff;
        font-size: 20px;
        font-family: "noto-sans", sans-serif;
        font-weight: 600;
        font-style: normal;
    }
    button.getInTouch {
        background-color: #D80E1F;
        border-color: #D80E1F!important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: 259px;
        height: 54px;
    }
    button.getInTouch:hover {
        background-color: #707070;
        border-color: #707070!important;
        color: #fff;
    }
    ::v-deep li.nav-item.navItems.ArrangeDemo > a:hover{
        color: #000!important;
    }
    @media only screen and (max-width: 500px) {
      .navbar-dark .navbar-nav .nav-link {
          /* color: rgb(255 255 255 / 50%); */
          z-index: 999;
          position: relative;
          color: #ffff;
          font-weight: 600;
      }
      img.storeIcons {
          width: 35px;
          padding-right: 5px;
          margin-right: 5px;
      }
      .logo {
          width: 150px;
          margin-left: -30px;
      }
      .Menu{
          padding-top: 5px;
          padding-bottom: 5px;
      }
      img.supportLogos {
          width: 50px;
          margin-top: 15px;
      }
      .clubText{
          color: #ffffff;
          font-style: italic;
          font-size: 13px;
          font-weight: bold;
          position: relative;
          top: 2px;
          left: -11px;
      }
    }
</style>
